/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Requested page does not exist
 * @export
 * @interface GetCharactersCharacterIdAssetsNotFound
 */
export interface GetCharactersCharacterIdAssetsNotFound {
    /**
     * error message
     * @type {string}
     * @memberof GetCharactersCharacterIdAssetsNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdAssetsNotFound interface.
 */
export function instanceOfGetCharactersCharacterIdAssetsNotFound(value: object): value is GetCharactersCharacterIdAssetsNotFound {
    return true;
}

export function GetCharactersCharacterIdAssetsNotFoundFromJSON(json: any): GetCharactersCharacterIdAssetsNotFound {
    return GetCharactersCharacterIdAssetsNotFoundFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdAssetsNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdAssetsNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetCharactersCharacterIdAssetsNotFoundToJSON(json: any): GetCharactersCharacterIdAssetsNotFound {
    return GetCharactersCharacterIdAssetsNotFoundToJSONTyped(json, false);
}

export function GetCharactersCharacterIdAssetsNotFoundToJSONTyped(value?: GetCharactersCharacterIdAssetsNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

